import { useEffect, useState } from "react";
import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";
import { NavLink,useLocation } from "react-router-dom";
import logo from "../../../assets/logo/logo_2.png";

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activePath, setActivePath] = useState("/");
    const location = useLocation();
    useEffect(() => { setActivePath(location.pathname); }, [location.pathname]);
  const menuItems = [
    { name: "Home", href: "/" },
    { name: "About Us", href: "/about-us" },
    { name: "Products", href: "/products" },
    { name: "Services", href: "/services" },
    { name: "Applications", href: "/applications" },
    { name: "Contact Us", href: "/contact-us" },
  ];


  /* LOCK BODY SCROLL WHEN MENU OPEN */
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [mobileOpen]);

  return (
    <>
      {/* HEADER */}
      <header
        className={`
          fixed top-0 w-full z-50 transition-all duration-300 bg-white py-6 backdrop-blur-lg shadow-md
          
        `}
      >
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between z-[99999]">
          {/* LOGO */}
          <div
            className={`text-2xl font-bold transition-colors text-black
            `}
          >
           <img
                  src={logo}
                  alt="ProRes"
                  className="w-[200px] h-auto lg:w-[240px] object-cover"
                />
          </div>

          {/* DESKTOP MENU */}
          <nav className="hidden lg:flex gap-10 items-center font-workSans font-medium">

            {menuItems.map((item) => 
              { const isActive = activePath === item.href; 
              return (
                 <NavLink 
                 key={item.href} 
                 to={item.href} 
                 className={`relative group pb-1 transition-all duration-300 text-gray-900  hover:text-red-600 ${isActive && "text-red-600 font-semibold"} `} > 
                 {item.name} 
                 {/* Animated Underline */} 
                 <span className={`absolute left-0 bottom-0 h-[2px] bg-red-600 rounded-full transition-all duration-300 scale-x-0 origin-left group-hover:scale-x-100 ${isActive ? "scale-x-100" : ""} `} 
                 style={{ width: "100%" }} /> 
                 </NavLink > ); 
                })}

            <NavLink
              to="/quote#quote-form"
              className={`
                ml-6 px-5 py-2 rounded-full font-medium shadow
                transition-all
                bg-red-600 text-white hover:bg-red-700
                
              `}
            >
              Get Quote
            </NavLink>
          </nav>

          {/* MOBILE TOGGLE */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`lg:hidden text-3xl text-gray-900
            `}
          >
            {mobileOpen ? <HiOutlineX /> : <HiOutlineMenu />}
          </button>
        </div>

      </header>

      {/* MOBILE MENU */}
      {mobileOpen && (
        <div
          className={`
            fixed top-[55px] left-0 right-0 bottom-0
            z-[9999] lg:hidden
            bg-white
            text-black
            backdrop-blur-md
            flex flex-col justify-between
          `}
        >

          <nav className="flex flex-col px-6 py-6 space-y-4 font-workSans">
            {menuItems.map((item) => (
              <NavLink
                key={item.href}
                to={item.href}
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) =>
                  `
                  text-lg transition
                  ${isActive
                    ? "text-red-600 font-semibold"
                    : "text-gray-900"}
                  hover:text-red-600
                `
                }
              >
                {item.name}
              </NavLink>
            ))}

          </nav>
          <div className="px-6 py-6 w-full">
            <NavLink
              to="/quote#quote-form"
              onClick={() => setMobileOpen(false)}
              className="block mt-6 text-center px-5 py-3 rounded-lg
                         bg-red-600 text-white font-semibold
                         shadow hover:bg-red-700 transition"
            >
              Get Quote
            </NavLink>
          </div>
        </div>
      )}
    </>
  );
}
